/* eslint-disable react/no-unknown-property */
import React from 'react';
import { observer } from 'mobx-react-lite';
import { tableStore } from '../../../stores/table-store';

const insertionLineStyle: React.CSSProperties = {
  position: 'absolute',
  left: 0,
  right: 0,
  height: '3px',
  zIndex: 100,
  pointerEvents: 'none',
};

export const InsertionLines = observer(({ rowIndex }: { rowIndex: number }) => {
  const { dragSession } = tableStore;
  // Lines render for multi-drag and for solo group drags — group drags
  // need the line to signal invalid group-in-group slots in red
  // (PSTUDIO-3160 C).
  const showLines = dragSession?.isMulti || tableStore.isGroupDrag;
  if (!showLines) return null;

  const insertionIndex = dragSession?.insertionIndex ?? null;
  const isInvalidDrop = dragSession?.isInvalidDrop ?? false;
  // The --ps-colors-* custom properties are not emitted at runtime — the
  // inline fallbacks are the design-system token values (purple-500 /
  // red-400 from _settings.colors.scss), same pattern as
  // drag-shadow-portal.
  const lineColor = isInvalidDrop
    ? 'var(--ps-colors-red-400, #ff4343)'
    : 'var(--ps-colors-purple-500, #8b5cf6)';

  const showAbove = insertionIndex === rowIndex;
  const visibleRowCount = tableStore
    .getAllSortedRows()
    .filter((row) => row.hidden !== true).length;
  const showBelow =
    insertionIndex === rowIndex + 1 && rowIndex === visibleRowCount - 1;

  return (
    <>
      {showAbove && (
        <tr
          className="c-editor-table-tr__insertion-line-row"
          style={{ height: 0 }}
        >
          <td
            colSpan={100}
            style={{ padding: 0, position: 'relative', border: 'none' }}
          >
            <div
              test-id="c-editor-table-insertion-line"
              data-drop-invalid={isInvalidDrop ? 'true' : undefined}
              style={{
                ...insertionLineStyle,
                backgroundColor: lineColor,
                top: 0,
              }}
            />
          </td>
        </tr>
      )}
      {showBelow && (
        <tr
          className="c-editor-table-tr__insertion-line-row"
          style={{ height: 0 }}
        >
          <td
            colSpan={100}
            style={{ padding: 0, position: 'relative', border: 'none' }}
          >
            <div
              test-id="c-editor-table-insertion-line"
              data-drop-invalid={isInvalidDrop ? 'true' : undefined}
              style={{
                ...insertionLineStyle,
                backgroundColor: lineColor,
                bottom: 0,
              }}
            />
          </td>
        </tr>
      )}
    </>
  );
});
